import React, { useEffect, useRef, useState } from "react";
import "./Welfare.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Welfare = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Benefit Management Systems",
      description: "Comprehensive digital systems for efficient welfare benefit distribution and management",
      whatsappMessage: "Hello, I'm interested in Benefit Management Systems consultation.",
    },
    {
      id: 2,
      title: "Social Service Platforms",
      description: "Digital solutions connecting communities with social services and support",
      whatsappMessage: "Hello, I'm interested in Social Service Platforms consultation.",
    },
    {
      id: 3,
      title: "Welfare Analytics",
      description: "Data-driven insights for improved social program outcomes and operational efficiency",
      whatsappMessage: "Hello, I'm interested in Welfare Analytics consultation.",
    },
    {
      id: 4,
      title: "Grant Management Software",
      description: "Streamlined solutions for welfare grant applications and fund distribution",
      whatsappMessage: "Hello, I'm interested in Grant Management Software consultation.",
    },
    {
      id: 5,
      title: "Community Engagement Tools",
      description: "Solutions to improve communication and participation in welfare programs",
      whatsappMessage: "Hello, I'm interested in Community Engagement Tools consultation.",
    },
    {
      id: 6,
      title: "Welfare IoT Solutions",
      description: "Connected devices for monitoring and supporting vulnerable communities",
      whatsappMessage: "Hello, I'm interested in Welfare IoT Solutions consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="welfare-page">
      <Helmet>
        <title>
          Welfare Technology Solutions | Innovative Social Welfare Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive welfare technology solutions including benefit management systems, social service platforms, welfare analytics, and community engagement tools."
        />
        <meta
          name="keywords"
          content="welfare technology, social services software, benefit management systems, welfare analytics, grant management, community engagement, welfare IoT, compliance, welfare solutions, social technology, welfare informatics, digital welfare, welfare innovation, social apps, welfare data, community support, welfare SaaS, social program management, welfare digital transformation"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="welfare-hero">
        <div className="welfare-hero-content">
          <h1 className="welfare-hero-title">
            Transforming <span className="welfare-highlight">Social Welfare</span>
          </h1>
          <p className="welfare-hero-description">
            We deliver cutting-edge welfare solutions that transform community support, streamline social services, and improve outcomes. From benefit management systems to community platforms and AI-powered assistance programs.
          </p>
          <div className="welfare-hero-buttons">
            <a href="/contact-us">
              <button className="welfare-btn welfare-btn-primary">
                Get Started
              </button>
            </a>
            <button className="welfare-btn welfare-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="welfare-hero-visual">
          <div className="welfare-animated-community">
            <div className="welfare-community-pulse"></div>
            <div className="welfare-support-hands"></div>
            <div className="welfare-connection-network"></div>
          </div>
          <div className="welfare-orb welfare-orb-1"></div>
          <div className="welfare-orb welfare-orb-2"></div>
          <div className="welfare-orb welfare-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="welfare-services">
        <div className="welfare-services-header">
          <h2 className="welfare-section-title">
            Our Welfare Solutions
          </h2>
          <p className="welfare-section-subtitle">
            Innovative welfare technology services designed to transform social services, enhance community experiences, and improve outcomes in the digital welfare landscape.
          </p>
        </div>

        <div className="welfare-services-grid">
          {/* Benefit Management Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-benefits"></div>
            </div>
            <h3>Benefit Management Systems</h3>
            <p>
              Comprehensive digital systems for efficient welfare benefit distribution and management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Eligibility Assessment</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Application Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Distribution</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Secure Data Access</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Social Services Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-social"></div>
            </div>
            <h3>Social Service Platforms</h3>
            <p>
              Digital solutions connecting communities with social services and support networks.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Service Directory</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Resource Matching</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Case Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Secure Messaging</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Faster Access</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">85%</div>
                <div className="stat-label">User Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Welfare Analytics Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-analytics"></div>
            </div>
            <h3>Welfare Analytics</h3>
            <p>
              Data-driven insights for improved program outcomes and operational efficiency.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Program Impact</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Metrics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Custom Reporting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Better Outcomes</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Decisions</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Grant Management Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-grants"></div>
            </div>
            <h3>Grant Management Software</h3>
            <p>
              Streamlined solutions for welfare grant applications and fund distribution.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Application Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Fund Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Reporting Tools</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Faster Processing</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Community Engagement Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-engagement"></div>
            </div>
            <h3>Community Engagement Tools</h3>
            <p>
              Solutions to improve communication, participation, and feedback in welfare programs.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Community Portals</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Event Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Resource Sharing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Feedback Collection</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Participation Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">75%</div>
                <div className="stat-label">Satisfaction Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Welfare IoT Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-iot"></div>
            </div>
            <h3>Welfare IoT Solutions</h3>
            <p>
              Connected devices for monitoring and supporting vulnerable communities.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Remote Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Emergency Alerts</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Accessibility Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Data Integration</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Response Improvement</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Monitoring Efficiency</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Housing Support Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-housing"></div>
            </div>
            <h3>Housing Support Systems</h3>
            <p>
              Comprehensive solutions for housing assistance programs and shelter management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Application Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Eligibility Verification</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Property Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Maintenance Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Processing Time</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Welfare AI Card */}
          <div className="welfare-service-card">
            <div className="welfare-service-icon">
              <div className="welfare-icon welfare-icon-ai"></div>
            </div>
            <h3>Welfare AI & Assistance</h3>
            <p>
              AI-powered solutions for needs assessment, resource allocation, and program optimization.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Needs Assessment</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Resource Allocation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Program Optimization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Analysis</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="welfare-services-cta">
          <h3>Ready to transform your welfare services?</h3>
          <p>
            Schedule a free consultation with our welfare technology experts to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="welfare-consultation-container">
              <button
                className="welfare-primary-btn welfare-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="welfare-modal-overlay">
                  <div className="welfare-modal-content">
                    <button
                      className="welfare-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="welfare-modal-title">
                      Welfare Technology Consultation
                    </h2>
                    <p className="welfare-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="welfare-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`welfare-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="welfare-option-title">
                            {option.title}
                          </h3>
                          <p className="welfare-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`welfare-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="welfare-btn welfare-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="welfare-stats">
        <div className="welfare-stats-container">
          <div className="welfare-stat">
            <h3 className="welfare-stat-number" data-count="250">
              250
            </h3>
            <p className="welfare-stat-label">Welfare Projects</p>
          </div>
          <div className="welfare-stat">
            <h3 className="welfare-stat-number" data-count="98">
              212
            </h3>
            <p className="welfare-stat-label">Client Satisfaction</p>
          </div>
          <div className="welfare-stat">
            <h3 className="welfare-stat-number" data-count="15">
              11
            </h3>
            <p className="welfare-stat-label">Years Experience</p>
          </div>
          <div className="welfare-stat">
            <h3 className="welfare-stat-number" data-count="40">
              40
            </h3>
            <p className="welfare-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="welfare-cta">
        <div className="welfare-cta-content">
          <h2>Ready to Transform Your Welfare Services?</h2>
          <p>
            Contact us today to discuss how our welfare technology expertise can help your organization innovate and improve community support.
          </p>
          <a href="/contact-us">
            <button className="welfare-btn welfare-btn-primary welfare-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Welfare;